/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChangeRequestCompetitorUpdateRequest = {
    discountedRequestSellingPrice?: number;
    salesStartDate?: string;
    salesEndDate?: string;
    otherSpecialReports?: string;
    competitorStoreCode?: string;
    expandSalesFloor?: ChangeRequestCompetitorUpdateRequest.expandSalesFloor;
    packingCategory?: ChangeRequestCompetitorUpdateRequest.packingCategory;
    saleType?: ChangeRequestCompetitorUpdateRequest.saleType;
};
export namespace ChangeRequestCompetitorUpdateRequest {
    export enum expandSalesFloor {
        REGULAR = 'REGULAR',
        END = 'END',
        WAGON = 'WAGON',
        FLYER = 'FLYER',
    }
    export enum packingCategory {
        SINGLE_ITEM = 'SINGLE_ITEM',
        BALL = 'BALL',
        CASE = 'CASE',
        BUNDLE = 'BUNDLE',
        OTHER = 'OTHER',
    }
    export enum saleType {
        DAILY = 'DAILY',
        WEEKLY = 'WEEKLY',
        WEEKEND = 'WEEKEND',
        MONTHLY = 'MONTHLY',
        OTHER = 'OTHER',
    }
}

